import 'sharer.js'

export default class socialShareButton {
    constructor (element) {
        this.element = element
        this.title = element?.getAttribute('data-title')
        this.url = element?.getAttribute('data-url')
        this.sharerButtons = this.element.querySelectorAll('button[data-sharer]')

        if (!this.title || this.title === '') {
            this.title = this.getCurrentPageTitle()
            this.setTitleAttributeForSharerButtons()
        }
        if (!this.url || this.url === '') {
            this.url = this.getCurrentPageUrl()
            this.setUrlAttributeForSharerButtons()
        }
    }

    getCurrentPageUrl () {
        return window.location.href
    }

    getCurrentPageTitle () {
        return document.querySelector('title').innerText
    }

    setTitleAttributeForSharerButtons () {
        this.sharerButtons.forEach(button => {
            button.setAttribute('data-title', this.title)

            if (button.hasAttribute('data-subject')) {
                button.setAttribute('data-subject', this.title)
            }
        })
    }

    setUrlAttributeForSharerButtons () {
        this.sharerButtons.forEach(button => {
            button.setAttribute('data-url', this.url)
        })
    }
}
